import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=7b0de96c&scoped=true"
import script from "./MenuList.vue?vue&type=script&lang=ts"
export * from "./MenuList.vue?vue&type=script&lang=ts"
import style0 from "./MenuList.vue?vue&type=style&index=0&id=7b0de96c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0de96c",
  null
  
)

export default component.exports